<template>
    <b-tabs>
        <b-tab :title="'Detalhes'">
            <template slot="title">
                <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Detalhes</span></div>
            </template>
            <UserEditForm :corretor="corretor" :editCustomer="true" :showCreci="false" :editUserData="editUserData" v-on:updateView="updateView"></UserEditForm>
        </b-tab>

        <div class="table-enterprise">
          <b-tab :title="'Empreendimentos'">
              <template slot="title">
                  <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Empreendimentos</span></div>
              </template>
              <HeadDetailsGama :titleHead="'Detalhe do cliente'"></HeadDetailsGama>
              <p class="details-title">Empreendimento do cliente</p>
              <Tables ref="tableEnterprise"
                :columns="headTableEnterprise"
                :showSearch="false"
                style="font-family:'Segoe UI'"
                :showPrint="false"
                :showHeader="false"
                :showPaging="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
              >
                <tr v-for="entreprise in entreprisesUserArray" :key="entreprise.id">
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.nomeEmpreendimento" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.cep" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.cidade" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.endereco" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.bairro" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.numero" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.apartamento" />
                  <TableColumn :IsText="true"    :status="1" :value="entreprise.torre" />
                </tr>
              </Tables>
          </b-tab>
        </div>

        <div class="table-installments">
          <b-tab :title="'Financeiro'">
              <template slot="title">
                  <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Financeiro</span></div>
              </template>
              <HeadDetailsGama :titleHead="'Detalhe do cliente'" :selectHead="true">
                  <template slot="selectTable">
                      <select v-model="enterpriseUnit" class="select-financial">
                          <option class="option-financial" :value="null">Selecione um empreendimento</option>
                          <option class="option-financial" :value="enterprise.empreendimentoUnidadeId" v-for="enterprise in entreprisesUserArray" :key="enterprise.id">{{enterprise.nomeEmpreendimento}} - {{enterprise.apartamento}}</option>
                      </select>
                  </template>
              </HeadDetailsGama>
              <p class="details-title">Parcelas</p>
              <div class="container-installments">
                  <div class="header-installments">Parcelas</div>
                  <div class="content-installments">
                      <div class="installment">
                          <div class="amount">{{customerInstallments.installmentsPaid}}</div>
                          <div class="label-installments">Pagas</div>
                      </div>
                      <div class="installment">
                          <div class="amount">{{customerInstallments.installmentsOverdue }}</div>
                          <div class="label-installments">Vencidas</div>
                      </div>
                      <div class="installment">
                          <div class="amount">{{customerInstallments.installmentsDue}}</div>
                          <div class="label-installments">A vencer</div>
                      </div>
                      <div class="installment">
                          <div class="amount">{{customerInstallments.installmentsFuture}}</div>
                          <div class="label-installments">Futuras</div>
                      </div>
                  </div>
              </div>
              <p class="details-title">Boletos</p>
              <Tables ref="tableTickets"
                :columns="headTableTickets"
                :showSearch="false"
                style="font-family:'Segoe UI'"
                :showPrint="false"
                :showHeader="false"
                :showPaging="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
              >
                <tr v-for="ticket in customerTickets" :key="ticket.id">
                  <TableColumn :IsText="true"    :status="1" :value="ticket.valorFormatado" />
                  <TableColumn :IsText="true"    :status="1" :value="ticket.dataVencimentoFormatada" />
                  <TableColumn :IsText="true"    :status="1" :value="['Quitado', 'AVencer'][ticket.status]" />
                  <TableColumn :IsDocumentActions="true" :HasDownload="true" v-on:Download="onDownloadTicket(ticket.id)" :status="1"  />
                </tr>
              </Tables>
          </b-tab>
        </div>

        <div class="table-incomeReport">
          <b-tab :title="'Informe de rendimento'">
              <template slot="title">
                  <div><span class="d-md-down-none pl-1 pr-1 text-third text-tabs">Informe de rendimento</span></div>
              </template>
              <HeadDetailsGama :titleHead="'Detalhe do cliente'"></HeadDetailsGama>
              <p class="details-title">Comprovante de Rendimentos</p>
              <Tables ref="tableIncome"
                :key="indexTableIncome"
                :columns="headTableIncome"
                :showSearch="false"
                style="font-family:'Segoe UI'"
                :showPrint="false"
                :showHeader="false"
                :showPaging="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
              >
                <tr v-for="income in customerIncomes" :key="income.id">
                  <TableColumn :IsText="true"    :status="1" :value="income.nomeComprovante" />
                  <TableColumn :IsText="true"    :status="1" :value="income.dataEnvioFormatada" />
                  <TableColumn :IsDocumentActions="true" :HasDownload="true" v-on:Download="onDownloadIncome(income.id)" :status="1"  />
                </tr>
              </Tables>
              <div class="container-modal">
                <button @click="openModal" id="add-income-report-button">+</button>
                  <b-modal
                    hide-footer
                    centered
                    ref="add-income-report"
                    id="add-income-report"
                    :title="'Adicionar informe de renda'"
                    >
                    <template #modal-title>
                        <div class="header-title">Adicionar Informe de ReNDIMENTO</div>
                    </template>
                    <b-form v-on:submit.prevent="()=>{}">
                      <div class="container-income-form">
                        <b-form-group
                          id="input-group-name"
                          label="Nome do informe de rendimento:"
                          label-for="input-name"
                        >
                          <b-form-input
                            id="input-name"
                            name="input-name"
                            v-model="incomeReport.nomeComprovante"
                            type="text"
                            v-validate="{required: true}"
                            placeholder="Digite o nome do informe de rendimento"
                            required
                          ></b-form-input>
                        </b-form-group>
                        <!-- <b-form-group
                          id="input-group-name"
                          label="Importar um arquivo:"
                          label-for="input-name"
                        >
                        <b-form-file v-model="file" class="mt-3" ></b-form-file>
                        </b-form-group> -->
                        <input type="file" v-on:change="GetValueFile" id="impor-pdf" itemid="impor-pdf">
                        <div class="embaixo">
                          <div class="d-flex justify-content-center">
                            <div>
                              <div v-if="nameInput == '' " v-on:click="openFilePdf" class="Icon_donw_rendimento">
                                <i class="fas fa-file-image"></i>
                              </div>
                              <div v-if="nameInput != ''" v-on:click="openFilePdf" class="Icon_donw_rendimento">
                                <i class="fas fa-file-pdf"></i>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex justify-content-center">
                              <label>{{ this.nameInput }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="container-buttons-form">
                          <button @click="closeModal" class="button-cancel">
                            Cancelar
                          </button>
                          <button @click="upload" class="button-save">Salvar</button>
                        </div>
                      </div>
                    </b-form>
                  </b-modal>
              </div>
          </b-tab>
        </div>
    </b-tabs>
</template>

<script>
import CustomerTabs from './CustomerTabs.js'
export default CustomerTabs
</script>

<style scoped>
.container-buttons-form{
  display: flex;
  justify-content: center;
  column-gap: 4rem;
}
.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 14PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 160px;
  height: 35px;
}

.button-cancel{
  background-color: #9d0000;
  color: #ffffff;
}
.button-save{
  background-color: #008148;
  color: white;

}
#impor-pdf {
  display: none;
}
.embaixo {
  margin: 1rem 0 1rem 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 460px;
  height: 100px;
  border-style: dotted;
  border-radius: 10px 10px 10px 10px;

}
.Icon_donw_rendimento {
  align-items: center;
  padding: 7px;
  display: flex;
  color: rgb(147, 137, 139);
  font-size: 50px;
  justify-content: center;
  cursor: pointer;

}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
#add-income-report-button{
  font-size: 28px;
  background-color: #008144;
  outline: transparent;
  color:white;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border:transparent
}

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.details-title{
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #008148;
    width: 350px;
    border:transparent;
}

.select-financial{
    height: 100%;
    width: 100%;
    padding: 0 10px 0 10px;
    background-color: #008148;
    color: white;
    text-transform: capitalize;
    outline: none;
    font-size: 14px;
}

.container-installments{
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e9e9e9;
}

.header-installments{
  background-color: #f7f7f7;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4f4c4d;
  font-size: 16px;
  border-bottom: 1px solid #e9e9e9;
}

.content-installments{
  display: flex;
  justify-content: space-around;
}

.installment{
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #e9e9e9;
  width: 100%;
  padding: 15px;
}

.installment:last-child{
  border-right: none;
}

.amount{
  font-size: 26px;
  font-weight: bold;
  color: #4f4c4d;
  margin-bottom: 4px;
}

.label-installments{
  text-transform: capitalize;
}

.text-tabs{
color: #008144;
}

/* Enterprise */

.table-enterprise thead, .table-enterprise tbody{
  display: flex;
}

.table-enterprise tbody{
  overflow-y: auto;
  height: auto;
}

.table-enterprise th,
.table-enterprise td {
  width: 300px;
}

/* Installments */

.table-installments thead, .table-installments tbody{
  display: flex;
}

.table-installments tbody{
  overflow-y: auto;
  height: auto;
}

.table-installments th,
.table-installments td {
  width: 400px;
}

/* Income Report */

.table-incomeReport tbody{
  overflow-y: auto;
  height: auto;
}

.table-incomeReport th,
.table-incomeReport td {
  width: 50%;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/CustomerTabs/CustomerTabs.vue